import Swiper, {Navigation} from 'swiper';

Swiper.use([Navigation]);
export default class Slider {
    constructor() {
        this.slider();
    }

    slider() {

        if (document.querySelector('#tabs')) {

            const slider = new Swiper('#tabs .swiper-container', {

                sliderPerView: 1,
                spaceBetween: 20,

                navigation: {
                    nextEl: '#tabs .swiper-button-next',
                    prevEl: '#tabs .swiper-button-prev',
                },
                breakpoints: {

                    // when window width is >= 640px

                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    }
                }
            });
        }

        if (document.querySelector('#offerte #steps')) {

            const slider = new Swiper('#offerte #steps .swiper-container', {

                sliderPerView: 1,
                spaceBetween: 20,

                navigation: {
                    nextEl: '#steps .swiper-button-next',
                    prevEl: '#steps .swiper-button-prev',
                },
                breakpoints: {

                    // when window width is >= 640px

                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    }
                }
            });
        }

        if (document.querySelector('#steps')) {

            const slider = new Swiper('#steps .swiper-container', {

                sliderPerView: 1,
                spaceBetween: 20,

                navigation: {
                    nextEl: '#steps .swiper-button-next',
                    prevEl: '#steps .swiper-button-prev',
                },
                breakpoints: {

                    // when window width is >= 640px

                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    }
                }
            });
        }

        if (document.querySelector('#reviews')) {

            const slider = new Swiper('#reviews .swiper-container', {

                sliderPerView: 1,
                spaceBetween: 20,

                navigation: {
                    nextEl: '#reviews .swiper-button-next',
                    prevEl: '#reviews .swiper-button-prev',
                },

            });
        }

        if (document.querySelector('#employees')) {

            const slider = new Swiper('#employees .swiper-container', {

                sliderPerView: 1,
                spaceBetween: 20,

                navigation: {
                    nextEl: '#employees .swiper-button-next',
                    prevEl: '#employees .swiper-button-prev',
                },
                breakpoints: {

                    // when window width is >= 640px

                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    }
                }

            });
        }
    }
}
